import httpClient from '@/api/http-client';
import getFormData from '@/util/form-data';

const endpoint = 'api/documents';

const documentService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  update: (document) => httpClient.put(`${endpoint}/${document.id}`, document),

  delete: (document) => httpClient.delete(`${endpoint}/${document.id}`),

  // create: (document) => {
  //   const formData = new FormData();
  //   Object.keys(document).forEach((key) => {
  //     if (key !== 'files') {
  //       formData.append(key, document[key]);
  //     }
  //   });
  //   for (let i = 0; i < document.files?.length; i++) {
  //     formData.append('files[]', document.files[i]);
  //   }
  //   return httpClient.post(`${endpoint}`, formData);
  // },

  create: (document) => {
    const doc = { ...document };
    if (doc.type === 'clean_criminal_record') {
      doc.type = `${doc.type}_${doc.clean_criminal_record_country}`;
    }
    const fieldBlacklist = ['subject', 'user', 'clean_criminal_record_country'];
    const formData = getFormData(doc, fieldBlacklist);
    if (!document.documents?.length) {
      // to receive document validation messages, when no files is selected
      formData.append('documents[]', '');
    }
    return httpClient.post(`${endpoint}`, formData);
  },

  copyPermitDocument: (document) =>
    httpClient.put(`${endpoint}/${document.document_id}/permit-documents-copy`, document),

  updateDocumentDates: (document) =>
    httpClient.put(`${endpoint}/${document.document_id}/update-dates`, document),
};

export default documentService;
